<template>
  <div class="gd624-status-bar mb-15">
    <div class="common-border">
      <div class="status-bar-item" v-for="item in options" :key="item.prop">
        <span :class="['iconfont', item.icon]"></span>
        <span class="label">{{ $t(item.label) }}</span>
        <span>{{ getValue(item) }}</span>
        <span>{{ item.unit }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty } from '@/utils/is';
export default {
  props: {
    model: Object,
    options: Array
  },
  methods: {
    getValue(item) {
      const v = this.model[item.prop];

      const format = item.format;

      if (format) {
        return format(v);
      }

      return isEmpty(v) ? '--' : v;
    }
  }
};
</script>

<style lang="scss">
.gd624-status-bar {
  height: 60px;
  font-size: 18px;

  .label {
    margin-right: 5px;

    &::after {
      content: ': ';
    }
  }

  .overall-status {
    font-weight: bold;
  }

  .common-border {
    height: 100%;
    padding: 0 20px;

    background-image: url('~@/assets/image/lt.png'), url('~@/assets/image/rt.png'),
      url('~@/assets/image/lb.png'), url('~@/assets/image/rb.png'),
      url('~@/assets/image/linelight.png');
    background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat;
    background-position: top left, top right, bottom left, bottom right, center -5px;

    display: flex;
    justify-content: space-around;
    align-items: center;

    .comp3-content {
      height: 100%;
      box-sizing: border-box;
    }

    .status-bar-item {
      display: flex;
      align-items: center;

      .iconfont {
        font-size: 26px !important;
        color: #0efcff !important;

        margin-right: 5px;
      }
    }
  }
}
</style>
